import React from "react";
import { MobileHidden, MobileOnly } from "../responsive/ResponsiveComponents";
import { DesktopHeader } from "./DesktopHeader";
import { MobileHeader } from "./MobileHeader";

export const GlobalHeader = React.memo(function GlobalHeader(props: GlobalHeaderProps) {
    const { withSideMenu } = props;

    return (
        <>
            <MobileHidden>
                <DesktopHeader withSideMenu={withSideMenu} />
            </MobileHidden>
            <MobileOnly>
                <MobileHeader withSideMenu={withSideMenu} />
            </MobileOnly>
        </>
    );
});

export type GlobalHeaderProps = {
    withSideMenu?: boolean
}
